import React from 'react';
import { SUMMARY_CARDS } from './constants';
import OverviewPanel from './OverviewPanel';

const cardClass = (active) =>
  `rounded-2xl border px-4 py-3 text-left transition-colors ${
    active ? 'border-orange-400 bg-orange-50' : 'border-gray-200 bg-gray-50 hover:border-orange-200'
  }`;

const SummaryPanel = ({ summary, firmwareStatus, onStatusChange }) => (
  <OverviewPanel title="Сводка по версиям" hint="По всем Метронам, без учёта фильтров списка">
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4">
      {SUMMARY_CARDS.map(({ status, field, label }) => {
        const active = firmwareStatus === status;

        return (
          <button key={field} type="button" className={cardClass(active)} onClick={() => onStatusChange(active && status ? '' : status)}>
            <div className="text-xs uppercase text-gray-400">{label}</div>
            <div className="text-2xl font-medium text-gray-800 mt-1">{summary?.[field] ?? 0}</div>
          </button>
        );
      })}
    </div>

    {summary?.by_version?.length ? (
      <div className="flex flex-wrap gap-2 mt-4">
        {summary.by_version.map(({ version, count }, index) => (
          <div
            key={`${version || 'unknown'}-${index}`}
            className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-50 border border-gray-200 text-sm text-gray-700">
            <span className="font-medium text-primary-500">{version || 'неизвестно'}</span>
            <span>{count ?? 0} шт.</span>
          </div>
        ))}
      </div>
    ) : null}
  </OverviewPanel>
);

export default SummaryPanel;
